import { UIElement } from '../ui-element';
import { Component } from '../../decorators/component.decorator';
import { Attribute } from '../../decorators/attribute.decorator';
import styles from '../divider/ui-divider.css';

/**
 * @typedef ({'section' | ''}) UIDividerLayout - Layout style of the divider.
 */
type UIDividerLayout = 'section' | '';

/**
 * @class
 * @memberof SharedComponents
 * @augments {UIElement}
 * @alias UIDivider
 * @element ui-divider
 * @property {UIDividerLayout} [layout] {@attr expanded} - Layout style of the divider.
 * @classdesc Represents a class for <code>ui-divider</code> element.
 * @example
 * <ui-divider></ui-divider>
 */
@Component({
    tag: 'ui-divider',
    styles,
})
export class UIDivider extends UIElement {
    @Attribute(String) layout?: UIDividerLayout;
}
